module.exports = __webpack_public_path__ + "img/04-round-convex-2.b34d6ffc.svg";